import { mapActions, mapGetters, mapState } from 'vuex';
import constants from '@/constants';
import ls from '@/helpers/localStorage';
import { MODALS } from '@/components/app/app-modals/app-modals';
import { parseQuery } from '@/utils/helpers';

export default {
  data() {
    return {
      fields: {
        newPassword: null,
        newPasswordConfirmation: null,
      },
      error: null,
      isAddingExternal: false, // Guard against duplicate API calls from race condition
    };
  },
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapGetters('app', ['hasMaintenance']),
    searchQuery() {
      return parseQuery(window.location.search);
    },
    hashQuery() {
      return parseQuery(window.location.hash);
    },
  },
  methods: {
    ...mapActions('notifications', ['setErrorSideNotification']),
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('user', ['addExternal', 'setToken', 'setRefreshToken', 'getUserInfo']),
    ...mapActions('profile', ['setProfileStatus']),
    handleAdd() {
      // Prevent duplicate calls caused by both app.js and this component calling getUserInfo()
      if (this.isAddingExternal) return;
      this.isAddingExternal = true;

      const payload = {
        externalAccessToken: this.hashQuery.access_token,
      };
      this.addExternal(payload)
        .then(() => this.goToTarget())
        .catch(() => this.handleError());
    },
    handleRegister() {
      this.$router.push({ name: 'home' });
      this.setCurrentPopup(MODALS.REGISTER_EXTERNAL);
    },
    handleLogin() {
      this.setProfileStatus({ event: 'login' });
      ls.del('externalToken');
      if (this.hashQuery.refresh_token) {
        this.setRefreshToken(this.hashQuery.refresh_token);
      }
      this.setToken(this.hashQuery.access_token);
      this.goToTarget();
    },
    handleError(message = 'Login Cancelled or Failed.') {
      ls.del('externalToken');
      this.setErrorSideNotification(message);
      setTimeout(
        () => this.$router.push({ name: 'home' }),
        constants.DEFAULT_SMALL_POPUP_TIMEOUT);
    },
    goToTarget() {
      if (this.searchQuery.redirect) {
        this.$router.push(this.searchQuery.redirect);
      } else {
        this.$router.push({ name: 'home' });
      }
    },
  },
  watch: {
    userInfo(data) {
      if (this.searchQuery.type === constants.SOCIAL_LOGIN_ADD) {
        this.handleAdd();
      } else if (!this.hasMaintenance && data && data.hasRegistered === false) {
        this.handleRegister();
      } else if (data && data.hasRegistered === true) {
        this.handleLogin();
      } else {
        this.handleError();
      }
    },
  },
  created() {
    if (this.hashQuery.access_token) {
      if (this.searchQuery.type === constants.SOCIAL_LOGIN_OR_REGISTER) {
        ls.set('externalToken', this.hashQuery.access_token);
      }
      this.getUserInfo()
        .catch(() => this.handleError());
    } else if (this.hashQuery.error) {
      this.handleError();
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-social-auth/account-social-auth.js